import { render } from "./latestBidsGala.vue?vue&type=template&id=7611311c&scoped=true"
import script from "./latestBidsGala.vue?vue&type=script&lang=js"
export * from "./latestBidsGala.vue?vue&type=script&lang=js"

import "./latestBidsGala.vue?vue&type=style&index=0&id=7611311c&scoped=true&lang=css"
import "./latestBidsGala.vue?vue&type=style&index=1&id=7611311c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7611311c"]])

export default __exports__